import AbsComponent from "../AbsComponent";

class Level extends AbsComponent{

    #minEl = {};
    #maxEl = {};
    
    constructor(_store={}, _router={}, _el=''){
        super('class Level', _store, _router, _el);
        this.#minEl = $(this.el + ' input[name=min-level]');
        this.#maxEl = $(this.el + ' input[name=max-level]');

        let watchSelLvMin = this.watch(this.store.getState, 'selLvMin', this.isEqual);
        this.store.subscribe( watchSelLvMin( (newVal, oldVal, path) => this.#minEl.val(newVal) ) );

        let watchSelLvMax = this.watch(this.store.getState, 'selLvMax', this.isEqual);
        this.store.subscribe( watchSelLvMax( (newVal, oldVal, path) => this.#maxEl.val(newVal) ) );

        this.addEvents();
    }

    addEvents(){
        $(this.el + ' .gd-filter-level-wrap .gd-btn-input-level').on('click', (e)=>{
            // this.store.dispatch( this.actions.setStopListLoad(true) );
            // this.store.dispatch( this.actions.setListpage( 1 ) );
            this.router.goMultiParamSetListPage( {
                'lvmin': this.#minEl.val(),
                'lvmax': this.#maxEl.val()
            });
            // this.store.dispatch( this.actions.setStopListLoad(false) );
            // this.store.dispatch( this.actions.loadItemList(1) );
            return false;
        });
    }


} // end of class
export default Level;